import { Seller } from 'framework/sellers'

interface FazendinhaSeller {
  id: number
  slug_empresa: string
  nome_empresa: string
  foto_responsavel: string
  descricao_empresa: string
  nome_responsavel: string
  dias_entrega: string[]
  imagem_cabecalho: string
  endereco_negocio: string
}

export default function parser(seller: FazendinhaSeller): Seller {
  return {
    id: seller?.id.toString(),
    slug: seller?.slug_empresa,
    name: seller?.nome_empresa,
    description: seller?.descricao_empresa,
    avatar: {
      url: seller?.foto_responsavel,
    },
    header: {
      url: seller?.imagem_cabecalho,
    },
    responsible: seller?.nome_responsavel,
    delivery: seller?.endereco_negocio,
  }
}
